import { orpc } from "@/utils/orpc.client";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export const HOME_EDITORIAL_PAGE_LIMIT = 5;
export const HOME_TRENDING_OFFER_LIMIT = 6;

export function getHomeCatalogStatsQueryOptions() {
  return orpc.catalog.getStats.queryOptions({});
}

export function getHomeTrendingOffersQueryOptions(input: { currency: string }) {
  return orpc.deals.getTrendingOffers.queryOptions({ input });
}

export function getHomeStoreCountQueryOptions() {
  return orpc.deals.getStoreCount.queryOptions({});
}

export function getHomeEditorialQueryOptions(locale: ViewerLocale) {
  return orpc.featurePages.getLatest.queryOptions({
    input: { locale, limit: HOME_EDITORIAL_PAGE_LIMIT },
  });
}
